/** Search sources of the chat (server src/agents/sources.py): one stable key per source. */
export const SOURCE_KEYS = [
  'federal_law', 'treaties', 'cantonal_law',
  'bge', 'bger', 'bstger', 'bvger', 'ti_decisions', 'rtid_digests',
  'doctrine',
  'firm_documents', 'bank_statements',
] as const

export type SourceKey = typeof SOURCE_KEYS[number]

export type SourceGroup = 'laws' | 'caseLaw' | 'doctrine' | 'firm'

export type SourceSelection = Record<SourceKey, boolean>

/** The selector's groups (t('chat.context.groups.<group>')), in display order. */
export const SOURCE_GROUPS: ReadonlyArray<{ group: SourceGroup; keys: ReadonlyArray<SourceKey> }> = [
  { group: 'laws', keys: ['federal_law', 'treaties', 'cantonal_law'] },
  { group: 'caseLaw', keys: ['bge', 'bger', 'bstger', 'bvger', 'ti_decisions', 'rtid_digests'] },
  { group: 'doctrine', keys: ['doctrine'] },
  { group: 'firm', keys: ['firm_documents', 'bank_statements'] },
]

/** The sources of each lane checkbox saved before subproject 3c (chat_context_settings_v2). */
export const LEGACY_LANE_SOURCES: Readonly<Record<string, ReadonlyArray<SourceKey>>> = {
  federalLaw: ['federal_law'],
  treaties: ['treaties'],
  cantonalLaw: ['cantonal_law'],
  caseLaw: ['rtid_digests', 'ti_decisions'],   // never turns the federal courts on
  doctrine: ['doctrine'],
  firmDocuments: ['firm_documents'],
  bankStatements: ['bank_statements'],
}

/**
 * Sources that start unselected because they make every search slower (federal
 * case law, subproject 3c): whoever needs them ticks them.
 */
export const OPT_IN_SOURCES: ReadonlyArray<SourceKey> = ['bge', 'bger', 'bstger', 'bvger']
